import { IconMoon, IconSun } from '@tabler/icons-react';
import { IconButton } from '@/app/shared/ui';
import type { Theme } from '@/theme/ThemeContext';

export const ThemeSwitch = ({
  theme,
  toggleTheme,
  white = true,
}: {
  theme: Theme;
  toggleTheme: () => void;
  /**
   * Use a transparent / outline-on-white look when sitting on top of an
   * animated background or a colorful surface. Default true preserves the
   * legacy behavior of the login screen.
   */
  white?: boolean;
}) => (
  <IconButton
    onClick={toggleTheme}
    variant={white ? 'outline' : 'secondary'}
    icon={
      theme === 'light' ? (
        <IconMoon size={18} className="animate-fade" />
      ) : (
        <IconSun size={18} className="animate-fade" />
      )
    }
    aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
    className={
      white
        ? 'border-white/40 bg-white/10 text-white hover:bg-white/20 hover:text-white'
        : undefined
    }
  />
);
